import React from "react";

import { isValidPrefixMAMLData } from "helpers";
import { useUrlParams } from "hooks";
import { EntityType } from "types/search";

import ResultsPlaceholder from "./resultsPlaceholder";
import { useSearchSections } from "./useSearchSections";

import styles from "./search.module.scss";

const Search = () => {
	const pattern = useUrlParams().get("q") || "";

	let enables: EntityType[] = [
		"application",
		"merchant",
		"uw",
		"terminal",
		"tid",
		"installation",
		"user",
		"agent",
		"agentOffice",
		"pends",
		"boarding",
	];
	if (pattern && isValidPrefixMAMLData(pattern)) {
		enables = [
			"application",
			"merchant",
			"uw",
			"boarding",
			"tid",
			"installation",
		];
	}
	const {
		searching,
		isResultsFound,
		ApplicationSection,
		MerchantSection,
		UnderwritingSection,
		TerminalsSection,
		TidEquipmentSection,
		InstallationSection,
		UserSection,
		AgentSection,
		AgentOfficeSection,
		PendSection,
		BoardingSection,
	} = useSearchSections(pattern, enables);

	return (
		<div className={styles.searchPage}>
			<h1 className={styles.title}>Search Result</h1>
			{searching || isResultsFound ? (
				<div className={styles.results}>
					<ApplicationSection />
					<MerchantSection />
					<UnderwritingSection />
					<TerminalsSection />
					<PendSection />
					<BoardingSection />
					<TidEquipmentSection />
					<InstallationSection />
					<UserSection />
					<AgentSection />
					<AgentOfficeSection />
				</div>
			) : (
				<ResultsPlaceholder />
			)}
		</div>
	);
};

export default Search;
